import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { RADIO_GROUP_VALUES } from '../AnchorComponents/consts.js';
import BasicLinkPanel from './BasicLinkPanel.js';
import MultiSelectLinkPanel from './MultiSelectLinkPanel.js';
import { isEmpty } from 'lodash';
import 'wix-rich-content-common';
import '../Icons/AnchorsThumbnails/ParagraphIcon.js';
import '../Icons/AnchorsThumbnails/H1Icon.js';
import '../Icons/AnchorsThumbnails/H2Icon.js';
import '../Icons/AnchorsThumbnails/H3Icon.js';
import '../Icons/AnchorsThumbnails/H4Icon.js';
import '../Icons/AnchorsThumbnails/H5Icon.js';
import '../Icons/AnchorsThumbnails/H6Icon.js';
import '../Icons/AnchorsThumbnails/CodeBlockIcon.js';
import '../Icons/AnchorsThumbnails/BlockQuoteIcon.js';
import '../Icons/AnchorsThumbnails/ImageIcon.js';
import '../Icons/AnchorsThumbnails/GalleryIcon.js';
import '../Icons/AnchorsThumbnails/VideoIcon.js';
import '../Icons/AnchorsThumbnails/MapIcon.js';
import '../Icons/AnchorsThumbnails/ButtonIcon.js';
import '../Icons/AnchorsThumbnails/GiphyIcon.js';
import '../Icons/AnchorsThumbnails/FileIcon.js';
import 'classnames';
import './LinkPanelWrapper.js';
import './LinkPanel.js';
import 'wix-rich-content-common/libs/Tooltip';
import 'wix-rich-content-ui-components';
import './AdvancedCheckboxes.js';
import './consts.js';
import '../../link-panel-b048ad3c.js';
import '../../style-inject.es-746bb8ed.js';
import './LinkPanelDropdown.js';
import './LinkActionsButtons.js';
import '../AnchorComponents/AnchorPanel.js';
import '../../anchor-panel-898efaa4.js';
import '../AnchorComponents/anchorUtils.js';
import '../AnchorComponents/FilterDropdownElement.js';
import '../AnchorComponents/AnchorableElement.js';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common/libs/imageUtils';
import '../AnchorComponents/FilterDropdown.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class LinkModal extends PureComponent {
  constructor(props) {
    var _a;
    super(props);
    __publicField(this, "setInitialRadioGroupValue", () => {
      const { anchor } = this.props;
      return !anchor ? RADIO_GROUP_VALUES.EXTERNAL_LINK : RADIO_GROUP_VALUES.ANCHOR;
    });
    __publicField(this, "isAnchorDeleted", (anchor) => {
      return !this.anchorableBlocksData.anchorableBlocks.some((block) => anchor === block.key);
    });
    __publicField(this, "isDoneButtonEnable", () => {
      const { radioGroupValue } = this.state;
      if (radioGroupValue) {
        switch (radioGroupValue) {
          case RADIO_GROUP_VALUES.EXTERNAL_LINK: {
            const { linkPanelValues } = this.state;
            return linkPanelValues.isValid && !!linkPanelValues.url || this.props.hideUrlInput;
          }
          case RADIO_GROUP_VALUES.ANCHOR: {
            const { anchorPanelValues } = this.state;
            return !!anchorPanelValues.anchor;
          }
          default:
            console.error("Unknown radio");
            break;
        }
      } else {
        const { linkPanelValues } = this.state;
        return linkPanelValues.isValid && !!linkPanelValues.url || this.props.hideUrlInput;
      }
    });
    __publicField(this, "onDone", (e) => {
      const { radioGroupValue } = this.state;
      if (radioGroupValue) {
        switch (radioGroupValue) {
          case RADIO_GROUP_VALUES.EXTERNAL_LINK:
            this.onDoneLink(e);
            break;
          case RADIO_GROUP_VALUES.ANCHOR:
            this.onDoneAnchor(e);
            break;
          default:
            console.error("Unknown radio");
            break;
        }
      } else {
        this.onDoneLink(e);
      }
    });
    __publicField(this, "onDoneAnchor", (e) => {
      const { anchorPanelValues } = this.state;
      if (anchorPanelValues.anchor) {
        this.props.onDone({
          data: __spreadProps(__spreadValues({}, anchorPanelValues), {
            anchor: anchorPanelValues.anchor
          }),
          clickFromKeyboard: !e.detail
        });
      }
    });
    __publicField(this, "onDoneLink", (e) => {
      const { linkPanelValues } = this.state;
      if (linkPanelValues.isValid && linkPanelValues.url || this.props.hideUrlInput) {
        this.props.onDone({ data: linkPanelValues, clickFromKeyboard: !e.detail });
      } else if (linkPanelValues.url === "") {
        this.onDelete(e);
      }
    });
    __publicField(this, "onDelete", (e) => {
      this.props.onDelete({ clickFromKeyboard: !e.detail });
    });
    __publicField(this, "onCancel", (e) => this.props.onCancel({ clickFromKeyboard: !e.detail }));
    __publicField(this, "changeRadioGroup", (value) => {
      this.setState({ radioGroupValue: value });
    });
    __publicField(this, "onChangeLinkPanel", (linkPanelValues) => {
      this.setState({ linkPanelValues });
    });
    __publicField(this, "onChangeAnchorPanel", (anchorPanelValues) => {
      this.setState({ anchorPanelValues });
    });
    const { url, anchor, target, rel, editorState, linkTypes, hideUrlInput, anchorableBlocksData } = this.props;
    this.renderBasicLinkPanel = !linkTypes || isEmpty(linkTypes) || !Object.values(linkTypes).find((addon) => !!addon) || hideUrlInput;
    this.anchorableBlocksData = !this.renderBasicLinkPanel ? anchorableBlocksData : void 0;
    this.state = {
      linkPanelValues: {
        url,
        target,
        rel,
        sponsored: (_a = rel == null ? void 0 : rel.includes) == null ? void 0 : _a.call(rel, "sponsored")
      },
      anchorPanelValues: this.renderBasicLinkPanel ? void 0 : {
        anchor: !this.isAnchorDeleted(anchor) && anchor
      },
      radioGroupValue: this.renderBasicLinkPanel ? void 0 : this.setInitialRadioGroupValue()
    };
  }
  render() {
    var _a;
    const { radioGroupValue, linkPanelValues, anchorPanelValues } = this.state;
    const ariaProps = { "aria-labelledby": "mob_link_modal_hdr" };
    const {
      theme,
      isMobile,
      t,
      uiSettings,
      isActive,
      hideUrlInput,
      linkTypes,
      anchorTarget,
      relValue,
      experiments,
      langDir,
      showCloseButton
    } = this.props;
    const { linkPanel } = uiSettings || {};
    const {
      showNewTabCheckbox,
      showNoFollowCheckbox,
      showSponsoredCheckbox,
      showNoReferrerCheckbox
    } = linkPanel || {};
    const hasCheckboxes = showNewTabCheckbox || showNoFollowCheckbox || showSponsoredCheckbox || showNoReferrerCheckbox;
    const linkPanelAriaProps = { "aria-label": "Link management" };
    const sharedPanelsProps = __spreadProps(__spreadValues({
      theme,
      onEnter: this.onDone,
      onEscape: this.onCancel,
      t,
      ariaProps: linkPanelAriaProps,
      hideUrlInput
    }, uiSettings == null ? void 0 : uiSettings.linkPanel), {
      anchorTarget,
      relValue,
      experiments,
      langDir
    });
    const buttonsProps = {
      onSave: this.onDone,
      onCancel: this.onCancel,
      onDelete: this.onDelete,
      isActive,
      theme,
      t,
      isDoneButtonEnable: this.isDoneButtonEnable(),
      hideUrlInput,
      isMobile
    };
    const propsToPass = {
      theme,
      t,
      ariaProps,
      showNewTabCheckbox,
      showNoFollowCheckbox,
      showSponsoredCheckbox,
      showNoReferrerCheckbox,
      sharedPanelsProps,
      buttonsProps,
      radioGroupValue,
      changeRadioGroup: this.changeRadioGroup,
      linkPanelValues,
      onChangeLinkPanel: this.onChangeLinkPanel,
      onChangeAnchorPanel: this.onChangeAnchorPanel,
      anchorableBlocksData: this.anchorableBlocksData,
      anchorPanelValues,
      isMobile,
      blockPreview: (_a = linkTypes == null ? void 0 : linkTypes.anchor) == null ? void 0 : _a.blockPreview,
      hasCheckboxes,
      experiments,
      showCloseButton
    };
    return this.renderBasicLinkPanel ? /* @__PURE__ */ React.createElement(BasicLinkPanel, __spreadValues({}, propsToPass)) : /* @__PURE__ */ React.createElement(MultiSelectLinkPanel, __spreadValues({}, propsToPass));
  }
}
LinkModal.propTypes = {
  editorState: PropTypes.object.isRequired,
  // will be removed when all usages of this class will pass anchorableBlocksData
  anchorableBlocksData: PropTypes.object,
  url: PropTypes.string,
  anchor: PropTypes.string,
  target: PropTypes.bool,
  rel: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isActive: PropTypes.bool,
  isMobile: PropTypes.bool,
  anchorTarget: PropTypes.string,
  relValue: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  uiSettings: PropTypes.object,
  t: PropTypes.func,
  linkTypes: PropTypes.object,
  experiments: PropTypes.object,
  hideUrlInput: PropTypes.bool,
  langDir: PropTypes.string,
  showCloseButton: PropTypes.bool
};

export { LinkModal as default };
//# sourceMappingURL=LinkModal.js.map
